import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CTASection from './components/CTASection';
import TrustedBrands from './components/TrustedBrands';
import WhyChooseUs from './components/WhyChooseUs';
import Footer from './components/Footer';
import Products from './components/Products';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1);
      if (hash === 'products') {
        setCurrentPage('products');
      } else {
        setCurrentPage('home');
      }
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <div className="App">
      <Navbar />
      {currentPage === 'products' ? (
        <Products />
      ) : (
        <>
          <HeroSection />
          <CTASection />
          <WhyChooseUs />
          <TrustedBrands />
        </>
      )}
      <Footer />
    </div>
  );
}

export default App;

